<template>
  <router-view class="analysis-router" />
</template>

<script>

export default {}
</script>
